import { useState } from "react";

//import menus, { TSectionMenu } from '../frontend/data/section-menus';

interface TSectionMenu {
  title: string;
  icon: string;
  children: { label: string; url: string }[];
}

export default function SectionMenu({
  title,
  menus,
}: {
  title?: string;
  menus: TSectionMenu[];
}) {
  const [open, setOpen] = useState(-1);

  /*
  useEffect(() => {
    setOpen(-1);
  }, [window.location.pathname]);
*/

  return (
    <div className="section-menu">
      {title && <h2>{title}</h2>}
      <div>
        {menus.map((menu, idx) => (
          <SectionNav
            key={idx}
            menu={menu}
            open={idx === open}
            onBtnClick={() => setOpen(open === idx ? -1 : idx)}
          />
        ))}
      </div>
    </div>
  );
}

function SectionNav({
  menu,
  open,
  onBtnClick,
}: {
  menu: TSectionMenu;
  open: boolean;
  onBtnClick: () => void;
}) {
  return (
    <nav className={open ? "open" : undefined}>
      <button onClick={onBtnClick}>
        <i />
        <span>{menu.title}</span>
        <span className="svg">
          <img src={menu.icon} alt="" />
        </span>
      </button>
      <ul>
        {menu.children.map((item, idx) => {
          const external = !!item.url?.match(/^https?:/);
          return (
            <li key={idx}>
              <a
                href={item.url}
                target={external ? "_blank" : undefined}
                rel={external ? "noreferrer" : undefined}
              >
                {item.label}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
